import { render, staticRenderFns } from "./signTemplate.vue?vue&type=template&id=e894d66c&scoped=true&"
import script from "./signTemplate.vue?vue&type=script&lang=js&"
export * from "./signTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e894d66c",
  null
  
)

export default component.exports